<template>
    <div class="side d-flex align-items-center">
        <input
            type="checkbox"
            class="checkbox"
            :id="id"
            :value="value" 
            :disabled="disabled"
            :checked="modelValue"
            @change="$emit('update:modelValue', $event.target.checked)"/>
        <label :for="id" class="switch"><slot></slot></label>
    </div>
</template>

<script>
export default {
    name: 'CustomCheckBox',
    props: {
        modelValue: {
            type: Boolean,
            default: false
        },
        id: {
            type: String,
            default: 'checkbox'
        },
        value: {
            type: String,
            default: '',
        },
        disabled: {
            type: Boolean,
            default: false
        }
    }
}
</script>

<style lang="scss" scoped>

@import "../../assets/theme/default/colors";
div{display: block;}
body{background-color: #eee;}
#control{
    width: 580px;
    background: $white;
    padding: 35px;
    box-shadow: 1px 1px 1px 1px #eaeaea;
    margin: 5% auto 0% auto;
}
.side{
    margin: 0px 10px;
    display: inline-table;
}
label{
    cursor: pointer;
    font-size: 16px;
    line-height: 120%;
}

.checkbox {
    vertical-align: top;
    margin: 0 3px 0 0;
    width: 17px;
    height: 17px;
}
.checkbox:not(checked) { position: absolute; opacity: 0;}
.checkbox:not(checked) + label.switch {
    position: relative;
    padding: 0 0 0 60px;
    display: block;
    height: 30px;
}
.checkbox:not(checked) + label.switch:before {
    content: '';
    position: absolute;
    top: -2px;
    left: 8px;
    width: 40px;
    height: 24px;
    border-radius: 13px;
    border-color: $gray-light1;
    box-shadow: $gray-light1 0px 0px 0px 0px inset;
    transition: border 0.4s, box-shadow 0.4s;
    background-color: $gray-light1;
}
.checkbox:not(checked) + label.switch:after {
    content: '';
    position: absolute;
    top: 0;
    left: 9px;
    width: 20px;
    height: 20px;
    border-radius: 10px;
    background: $white;
    box-shadow: 0 2px 5px rgba(0,0,0,.3);
    transition: all .2s;
}
.checkbox:checked + label.switch:before {
    box-shadow: $green 0px 0px 0px 16px inset;
    transition: border 0.4s, box-shadow 0.4s, background-color 1.2s;
    background-color: $green;
    border-color: $green;
}
.checkbox:checked + label.switch:after { left: 26px;}

</style>